module.exports = __webpack_public_path__ + "img/logo_no_name.35646ced.png";